import React, {
    Dispatch,
    ReactNode,
    SetStateAction,
    createContext,
    useContext
} from "react";

import { Contact } from "../../../models";

type ContactContextType = {
    contacts?: Array<Contact>;
    setIsOpenCreateContactDialog?: Dispatch<SetStateAction<boolean>>;
};

const ContactContext = createContext<ContactContextType | null>(null);

export const ContactContextProvider = (props: ContactContextType & { children: ReactNode; }) => {
    return (
        <ContactContext.Provider value={props}>
            {props.children}
        </ContactContext.Provider>
    );
};

export const useContacts = () => {
    const context = useContext(ContactContext);
    if (!context) {
        throw new Error("useContactContext must be used within a ContactContextProvider");
    }
    return context;
};